<template>
	<v-container fluid grid-list-lg class="pa-3">
		<v-layout row wrap>
			<v-flex>
				<v-card>
					<v-toolbar dense prominent dark>
						<v-toolbar-title>Update FPES Entries</v-toolbar-title>
						<v-spacer></v-spacer>

						<v-toolbar-items>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn small fab v-on="on">
										<v-icon>receipt_long</v-icon>
									</v-btn>
								</template>
								<span>View log</span>
							</v-tooltip>
						</v-toolbar-items>
					</v-toolbar>

					<v-card-text>
						<v-container fluid class="pa-0">
							<v-layout row wrap>
								<v-flex xs12 sm4 xl1>
									<v-text-field label="User Name" readonly v-model="selected.username"></v-text-field>
								</v-flex>
								<v-flex xs12 sm8 xl2>
									<v-text-field label="Full Name" readonly v-model="selected.full_name"></v-text-field>
								</v-flex>
								<v-flex xs12 xl9>
									<v-text-field label="Company : Dept" readonly v-model="selected.company_dept"></v-text-field>
								</v-flex>
							</v-layout>

							<v-layout row wrap>
								<v-flex>
									<v-textarea label="Remark" v-model="selected.remark"></v-textarea>
								</v-flex>

							</v-layout>

							<v-layout row wrap>
								<v-flex xs12 sm3>
									<v-text-field label="EUL" v-model.number="selected.eul" type="Number"></v-text-field>
								</v-flex>
								<v-flex xs12 sm3>
									<v-text-field label="Lateness" v-model.number="selected.lateness" type="Number"></v-text-field>
								</v-flex>
								<v-flex xs12 sm3>
									<v-text-field label="MC" v-model.number="selected.mc" type="Number"></v-text-field>
								</v-flex>
								<v-flex xs12 sm3>
									<v-select :items="all_validity" item-value="_id" item-text="label" label="Validity" v-model="selected.validity_id"></v-select>
								</v-flex>
							</v-layout>

							<v-layout row wrap>
								<v-flex xs12 sm4>
									<v-select :items="all_rank" item-value="_id" item-text="label" label="Rank" v-model="selected.rank_id"></v-select>
								</v-flex>
								<v-flex xs12 sm4>
									<v-text-field label="Created By" readonly v-model="selected.created_by" :messages="epoch2date(selected.modified)"></v-text-field>
								</v-flex>
								<v-flex xs12 sm4>
									<v-text-field label="Last Modified By" readonly v-model="selected.modified_by" :messages="epoch2date(selected.modified)"></v-text-field>
								</v-flex>
							</v-layout>

							<v-layout>
								<v-flex xs12 class="text-sm-right">
									<v-btn color="dull" :href="'FPES-report?uuid=11c6e519-a679-4c24-89c9-c57cb3b94645&_id=' + selected.fpes_report_id">
										<v-icon left>cancel</v-icon>Cancel
									</v-btn>
									<v-btn color="primary" @click="save_update_onclick">
										<v-icon left>save</v-icon>Save Update
									</v-btn>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import general from "../../functions/general";

export default {
	name: "Update-Fpes-Report-Entries",
	data() {
		return {
			selected: {
				_id: "",
				username: "",
				full_name: "",
				created: 0,
				created_by: "",
				modified: 0,
				modified_by: "",
				company_dept:"",
				fpes_report_id: "",
				mc: 0,
				eul:0,
				lateness: 0,
				remark: "",
				validity_id: "",
				rank_id: "",
			},
			all_validity: [],
			all_rank: [],
		};
	},
	computed: {},
	methods: {
		epoch2date: general.App.epoch2LocaleDatetime,
		async save_update_onclick(){
			general.App.loader.show(this);
			let url = "fpes/fpes_report_entries/";
			let data = {
				_id:this.selected._id,
				lateness:this.selected.lateness,
				eul:this.selected.eul,
				mc:this.selected.mc,
				remark:this.selected.remark,
				validity_id:this.selected.validity_id,
				rank_id:this.selected.rank_id,
			};

			let result = await general.wBackEndComm.PutData(url, data);
			result = result.data;

			if (result.Status == 1) {
				general.wMsgBox.Success(result.Description);
				this.selected = general.App.update_obj_property_value(this.selected, result.Body);
			} else {
				general.wMsgBox.Error(result.Description);
			}
			general.App.loader.hide(this);
		},
	},
	async mounted() {
		general.App.loader.show(this);
		general.App.set_page_title("mySuite : Update FPES Entries Page.");

		this.all_validity = await general.App.arango_app_selections("fpes_report_entries", "validity");
		this.all_rank = await general.App.arango_app_selections("fpes_report_entries", "rank");
		this.selected._id = general.App.getQueryString("_id");

		let url = "fpes/fpes_report_entries/?_id=" + this.selected._id;

		let result1 = await general.wBackEndComm.GetData(url);
		result1 = result1.data;

		if (result1.Status == 1) {
			this.selected = result1.Body;
		} else {
			general.wMsgBox.Error(result1.Description);
		}

		general.App.loader.hide(this);
	},
};
</script>

<style></style>
